import { createSlice } from '@reduxjs/toolkit'
import { fetchStatus, fetchCurriences, fetchCountries, fetchPettyCashCategories, 
        fetchMaterialCategories, fetchMaterialBrands, fetchMaterialUoms, fetchMaterialIdTypes, fetchCompanyTypes,  
        fetchCompanySupplyType, fetchCompanySizeCategory, fetchCompanyBusinessTypes, fetchCompanyCreditPeriods, 
        fetchDocTypesData, fetchOrderTypesData, fetchStates, fetchMaterialSpecificationMandatoryTypes,
        fetchMaterialIdTeam, fetchHSNMasterData, fetchChequeBooks, fetchBankDetails, fetchTDSSections, fetchPinCodes,
        fetchTicketCategory, fetchTicketSubCategory, fetchTicketStatus, fetchUserListByCompanyId, fetchApprovals, fetchApprovalTypes, fetchCompanyWarehouses, fetchLogisticPartners, 
        fetchStockMoveTypes, fetchGSTRates, fetchIncoTerms, fetchTicketGroupAssignee, fetchTicketSubCategoryParams,fetchTicketConstraintAssignees, fetchTicketConstraintCategories, fetchPoRescheduleReasonList, fetchBuyerQuoteClosureReasonList, fetchClientSuccessManagers,
        fetchPMBranches,
        fetchApprovalSecondary,
        fetchBuyerCompaniesUsers,
        fetchBuyerCompanies,
        fetchCalendarHolidays,
        fetchFollowUpStatusData,
        fetchDeliveryStatusData,
        fetchVendorRCTypes,
        fetchVendorRCCoverageTypes,
        fetchTicketDetailedStatus,
        fetchLastCommentStructures,
        fetchCompanyRoleHierarchyData,
        fetchCompanyMSMEDTypes,
        fetchVMIQtyTypes,
        fetchOpsEditableMaterials,
		fetchNotificationTypes,
		fetchPriorities,
        fetchMaterialSpecifications,
        fetchQuoteClasses,
        fetchSkipSuggMarginReasons,
        fetchAdjustmentReasons,
        fetchVendorRateContracts,
        fetchCompanyTags
    } from './commonThunk'

export const commonSlice = createSlice({
    name : "common",
    initialState : {
        status: [],
        currencies: [],
        countries: [],
        pettycashCategories: [],
        materialCategories: [],
        materialBrands: [],
        materialUOMs: [],
        materialIdTypes: [],
        materialIdTeam: [],
        materialSpecificationMandatoryTypes: [],
        companyTypes: [],
        companySupplyType: [],
        companySizeCategories: [],
        companyBusinessTypes: [],
        companyCreditPeriods: [],
        companyWarehouses: [],
        docTypes: [],
        orderTypes: [],
        states: [],
        HSNMaster: [],
        chequeBooks: [],
        bankDetails: [],
        approvalTypes: [],
        approvals: [],
        incoTerms: [],
        chequeBooksSearchParams: {
            dataType: "chequeBooksData",
            searchBy: "all",
            searchText: "",
            statusId: [1, 2],
            chequeSeries: "all",
        },
        chequeBooksSearchOptions: [],
        tdsSections: [],
        ticketCategories: [],
        ticketSubCategories: [],
        ticketStatus: [],
        pinCodes: [],
        userList: [],
        logisticPartners: [],
        loading : false,
        stockMoveTypes: [],
        GSTRates: [],
        ticketGroupAssignee: [],
        ticketSubCategoryParams: [],
        ticketConstraintAssignees : [], 
        ticketConstraintCategories : [],
        poRescheduleReasonList: [],
        buyerQuoteClosureReasonList: [],
        clientSuccessManagers: [],
        PMBranches: [],
        approvalSecondary: [],
        buyerCompaniesUsers: [],
        buyerCompanies: [],
        calendarHolidays: [],
        followUpStatus: [],
        deliveryStatus: [],
        vendorRCTypes: [],
        vendorRCCoverageTypes: [],
        ticketDetailedStatus: [],
        lastCommentStructures: [],
        companyRoleHierarchy: [],
        companyMSMEDTypes: [],
        vmiQtyTypes: [],
        opsEditableMaterials: [],
		notificationTypes: [],
		priorities: [],
        materialSpecifications: [],
        quoteClasses: [],
        skipSuggMarginReasons: [],
        adjustmentReasons: [],
        vendorRateContracts: [],
        companyTags: []
    },
    reducers: {
        addChequeBookAction: (state, action) => {
            state.chequeBooks = action.payload
        },
        editChequeBookAction: (state, action) => {
            state.chequeBooks = action.payload
        },
        deleteChequeBookAction: (state, action) => {
            state.chequeBooks = action.payload
        },
        updateChequeBooksSearchOptions: (state, action) => {
            state.chequeBooksSearchOptions = action.payload
        },
        updateChequeBooksSearchParams: (state, action) => {
            state.chequeBooksSearchParams = action.payload
        },
    },
    extraReducers : (builder) => {
        builder
        .addCase(
            fetchStatus.fulfilled, (state, action) => {
                state.loading = false
                state.status = action.payload
            }
        )
        .addCase(
            fetchStatus.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchStatus.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchPettyCashCategories.fulfilled, (state, action) => {
                state.loading = false
                state.pettycashCategories = action.payload
            }
        )
        .addCase(
            fetchPettyCashCategories.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchPettyCashCategories.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialBrands.fulfilled, (state, action) => {
                state.loading = false
                state.materialBrands = action.payload
            }
        )
        .addCase(
            fetchMaterialBrands.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialBrands.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialUoms.fulfilled, (state, action) => {
                state.loading = false
                
                state.materialUOMs = action.payload
            }
        )
        .addCase(
            fetchMaterialUoms.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialUoms.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialCategories.fulfilled, (state, action) => {
                state.loading = false
                state.materialCategories = action.payload
            }
        )
        .addCase(
            fetchMaterialCategories.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialCategories.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCurriences.fulfilled, (state, action) => {
                state.loading = false
                state.currencies = action.payload
            }
        )
        .addCase(
            fetchCurriences.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCurriences.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCountries.fulfilled, (state, action) => {
                state.loading = false
                state.countries = action.payload
            }
        )
        .addCase(
            fetchCountries.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCountries.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialIdTypes.fulfilled, (state, action) => {
                state.loading = false
                state.materialIdTypes = action.payload
            }
        )
        .addCase(
            fetchMaterialIdTypes.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialIdTypes.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyTypes.fulfilled, (state, action) => {
                state.loading = false
                state.companyTypes = action.payload
            }
        )
        .addCase(
            fetchCompanyTypes.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyTypes.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanySupplyType.fulfilled, (state, action) => {
                state.loading = false
                state.companySupplyType = action.payload
            }
        )
        .addCase(
            fetchCompanySupplyType.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanySupplyType.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanySizeCategory.fulfilled, (state, action) => {
                state.loading = false
                state.companySizeCategories = action.payload
            }
        )
        .addCase(
            fetchCompanySizeCategory.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanySizeCategory.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyBusinessTypes.fulfilled, (state, action) => {
                state.loading = false
                state.companyBusinessTypes = action.payload
            }
        )
        .addCase(
            fetchCompanyBusinessTypes.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyBusinessTypes.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyCreditPeriods.fulfilled, (state, action) => {
                state.loading = false
                state.companyCreditPeriods = action.payload
            }
        )
        .addCase(
            fetchCompanyCreditPeriods.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyCreditPeriods.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyWarehouses.fulfilled, (state, action) => {
                state.loading = false
                state.companyWarehouses = action.payload
            }
        )
        .addCase(
            fetchCompanyWarehouses.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyWarehouses.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchDocTypesData.fulfilled, (state, action) => {
                state.loading = false
                state.docTypes = action.payload
            }
        )
        .addCase(
            fetchDocTypesData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchDocTypesData.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchOrderTypesData.fulfilled, (state, action) => {
                state.loading = false
                state.orderTypes = action.payload
            }
        )
        .addCase(
            fetchOrderTypesData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchOrderTypesData.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchStates.fulfilled, (state, action) => {
                state.loading = false
                state.states = action.payload
            }
        )
        .addCase(
            fetchStates.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchStates.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialSpecificationMandatoryTypes.fulfilled, (state, action) => {
                state.loading = false
                state.materialSpecificationMandatoryTypes = action.payload
            }
        )
        .addCase(
            fetchMaterialSpecificationMandatoryTypes.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialSpecificationMandatoryTypes.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchMaterialIdTeam.fulfilled, (state, action) => {
                state.loading = false
                state.materialIdTeam = action.payload
            }
        )
        .addCase(
            fetchMaterialIdTeam.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchMaterialIdTeam.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchHSNMasterData.fulfilled, (state, action) => {
                state.loading = false
                state.HSNMaster = action.payload
            }
        )
        .addCase(
            fetchHSNMasterData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchHSNMasterData.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchChequeBooks.fulfilled, (state, action) => {
                state.loading = false
                state.chequeBooks = action.payload
            }
        )
        .addCase(
            fetchChequeBooks.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchChequeBooks.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchBankDetails.fulfilled, (state, action) => {
                state.loading = false
                state.bankDetails = action.payload
            }
        )
        .addCase(
            fetchBankDetails.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchBankDetails.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchTDSSections.fulfilled, (state, action) => {
                state.loading = false
                state.tdsSections = action.payload
            }
        )
        .addCase(
            fetchTDSSections.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchTDSSections.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchTicketCategory.fulfilled, (state, action) => {
                state.loading = false
                state.ticketCategories = action.payload
            }
        )
        .addCase(
            fetchTicketCategory.pending, (state, action) => {
                state.loading = true 
            }

		)
		.addCase(
			fetchTicketCategory.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchTicketSubCategory.fulfilled, (state, action) => {
				state.loading = false
				state.ticketSubCategories = action.payload
			}
		)
		.addCase(
			fetchTicketSubCategory.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchTicketSubCategory.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchTicketStatus.fulfilled, (state, action) => {
				state.loading = false
				state.ticketStatus = action.payload
			}
		)
		.addCase(
			fetchTicketStatus.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchTicketStatus.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchPinCodes.fulfilled, (state, action) => {
				state.loading = false
				state.pinCodes = action.payload
			}
		)
		.addCase(
			fetchPinCodes.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchPinCodes.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchApprovalTypes.fulfilled, (state, action) => {
				state.loading = false
				state.approvalTypes = action.payload.data
			}
		)
		.addCase(
			fetchApprovalTypes.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchApprovalTypes.rejected, (state, action) => {
				state.loading = false 
			}
		)
		.addCase(
			fetchApprovals.fulfilled, (state, action) => {
				state.loading = false
				state.approvals = action.payload
			}
		)
		.addCase(
			fetchApprovals.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchApprovals.rejected, (state, action) => {
				state.loading = false 
			}
		)
		.addCase(
			fetchApprovalSecondary.fulfilled, (state, action) => {
				state.loading = false
				state.approvalSecondary = action.payload
			}
		)
		.addCase(
			fetchApprovalSecondary.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchApprovalSecondary.rejected, (state, action) => {
				state.loading = false 
			}
		)
		.addCase(
			fetchLogisticPartners.fulfilled, (state, action) => {
				state.loading = false
				state.logisticPartners = action.payload
			}
		)
		.addCase(
			fetchLogisticPartners.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchLogisticPartners.rejected, (state, action) => {
				state.loading = false 
			}
		)
		.addCase(
			fetchUserListByCompanyId.fulfilled, (state, action) => {
				state.loading = false
				state.userList = action.payload
			}
		)
		.addCase(
			fetchUserListByCompanyId.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchUserListByCompanyId.rejected, (state, action) => {
				state.loading = false 
			}
		)
		.addCase(
			fetchStockMoveTypes.fulfilled, (state, action) => {
				state.loading = false
				state.stockMoveTypes = action.payload
			}
		)
		.addCase(
			fetchStockMoveTypes.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchStockMoveTypes.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchGSTRates.fulfilled, (state, action) => {
				state.loading = false
				state.GSTRates = action.payload
			}
		)
		.addCase(
			fetchGSTRates.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchGSTRates.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchIncoTerms.fulfilled, (state, action) => {
				state.loading = false
				state.incoTerms = action.payload
			}
		)
		.addCase(
			fetchIncoTerms.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchIncoTerms.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchTicketGroupAssignee.fulfilled, (state, action) => {
				state.loading = false
				state.ticketGroupAssignee = action.payload
			}
		)
		.addCase(
			fetchTicketGroupAssignee.pending, (state, action) => {
				state.loading = true 
			}

		)
		.addCase(
			fetchTicketGroupAssignee.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchTicketSubCategoryParams.fulfilled, (state, action) => {
				state.loading = false
				state.ticketSubCategoryParams = action.payload
			}
		)
		.addCase(
			fetchTicketSubCategoryParams.pending, (state, action) => {
				state.loading = true 
			}

		)
		.addCase(
			fetchTicketSubCategoryParams.rejected, (state, action) => {
				state.loading = false
			}
		)

		.addCase(
			fetchTicketConstraintAssignees.fulfilled, (state, action) => {
				state.loading = false
				state.ticketConstraintAssignees = action.payload
			}
		)
		.addCase(
			fetchTicketConstraintAssignees.pending, (state, action) => {
				state.loading = true 
			}

		)
		.addCase(
			fetchTicketConstraintAssignees.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchTicketConstraintCategories.fulfilled, (state, action) => {
				state.loading = false
				state.ticketConstraintCategories = action.payload
			}
		)
		.addCase(
			fetchTicketConstraintCategories.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchTicketConstraintCategories.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchPoRescheduleReasonList.fulfilled, (state, action) => {
				state.loading = false
				state.poRescheduleReasonList = action.payload
			}
		)
		.addCase(
			fetchPoRescheduleReasonList.pending, (state, action) => {
				state.loading = true 
			}

		)
		.addCase(
			fetchPoRescheduleReasonList.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchBuyerQuoteClosureReasonList.fulfilled, (state, action) => {
				state.loading = false
				state.buyerQuoteClosureReasonList = action.payload
			}
		)
		.addCase(
			fetchBuyerQuoteClosureReasonList.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchBuyerQuoteClosureReasonList.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchClientSuccessManagers.fulfilled, (state, action) => {
				state.loading = false
				state.clientSuccessManagers = action.payload
			}
		)
		.addCase(
			fetchClientSuccessManagers.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchClientSuccessManagers.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchPMBranches.fulfilled, (state, action) => {
				state.loading = false
				state.PMBranches = action.payload
			}
		)
		.addCase(
			fetchPMBranches.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchPMBranches.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchBuyerCompaniesUsers.fulfilled, (state, action) => {
				state.loading = false
				state.buyerCompaniesUsers = action.payload
			}
		)
		.addCase(
			fetchBuyerCompaniesUsers.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchBuyerCompaniesUsers.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchBuyerCompanies.fulfilled, (state, action) => {
				state.loading = false
				state.buyerCompanies = action.payload
			}
		)
		.addCase(
			fetchBuyerCompanies.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchBuyerCompanies.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchCalendarHolidays.fulfilled, (state, action) => {
				state.loading = false
				state.calendarHolidays = action.payload
			}
		)
		.addCase(
			fetchCalendarHolidays.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchCalendarHolidays.rejected, (state, action) => {
				state.loading = false
			}
		).addCase(
			fetchVendorRCTypes.fulfilled, (state, action) => {
				state.loading = false
				state.vendorRCTypes = action.payload
			}
		)
		.addCase(
			fetchVendorRCTypes.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchVendorRCTypes.rejected, (state, action) => {
				state.loading = false
			}
		).addCase(
			fetchVendorRCCoverageTypes.fulfilled, (state, action) => {
				state.loading = false
				state.vendorRCCoverageTypes = action.payload
			}
		)
		.addCase(
			fetchVendorRCCoverageTypes.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchVendorRCCoverageTypes.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchFollowUpStatusData.fulfilled, (state, action) => {
				state.loading = false
				state.followUpStatus = action.payload
			}
		)
		.addCase(
			fetchFollowUpStatusData.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchFollowUpStatusData.rejected, (state, action) => {
				state.loading = false
			}
		)
		.addCase(
			fetchDeliveryStatusData.fulfilled, (state, action) => {
				state.loading = false
				state.deliveryStatus = action.payload
			}
		)
		.addCase(
			fetchDeliveryStatusData.pending, (state, action) => {
				state.loading = true 
			}
		)
		.addCase(
			fetchDeliveryStatusData.rejected, (state, action) => {
				state.loading = false
			}
		)

        .addCase(
            fetchTicketDetailedStatus.fulfilled, (state, action) => {
                state.loading = false
                state.ticketDetailedStatus = action.payload
            }
        )
        .addCase(
            fetchTicketDetailedStatus.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchTicketDetailedStatus.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchLastCommentStructures.fulfilled, (state, action) => {
                state.loading = false
                state.lastCommentStructures = action.payload
            }
        )
        .addCase(
            fetchLastCommentStructures.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchLastCommentStructures.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyRoleHierarchyData.fulfilled, (state, action) => {
                state.loading = false
                state.companyRoleHierarchy = action.payload
            }
        )
        .addCase(
            fetchCompanyRoleHierarchyData.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyRoleHierarchyData.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchCompanyMSMEDTypes.fulfilled, (state, action) => {
                state.loading = false
                state.companyMSMEDTypes = action.payload
            }
        )
        .addCase(
            fetchCompanyMSMEDTypes.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchCompanyMSMEDTypes.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchOpsEditableMaterials.fulfilled, (state, action) => {
                state.loading = false
                state.opsEditableMaterials = action.payload
            }
        )
        .addCase(
            fetchOpsEditableMaterials.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchOpsEditableMaterials.rejected, (state, action) => {
                state.loading = false
            }
        )
		.addCase(
			fetchNotificationTypes.fulfilled, (state, action) => {
				state.loading = false
				state.notificationTypes = action.payload
			})
		.addCase(
			fetchNotificationTypes.pending, (state) => {
				state.loading = true
			}
		)
		.addCase(
			fetchNotificationTypes.rejected, (state) => {
				state.loading = false
			}
		)
		.addCase(
			fetchPriorities.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchPriorities.fulfilled, (state, action) => {
                state.loading = false
                state.priorities = action.payload 
            }
		)
		.addCase(fetchPriorities.rejected, (state, action) => {
                state.loading = false
            }
		)
        .addCase(
			fetchMaterialSpecifications.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchMaterialSpecifications.fulfilled, (state, action) => {
                state.loading = false
                state.materialSpecifications = action.payload 
            }
		)
		.addCase(
            fetchMaterialSpecifications.rejected, (state, action) => {
                state.loading = false
            }
		)
        .addCase(
			fetchQuoteClasses.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchQuoteClasses.fulfilled, (state, action) => {
                state.loading = false
                state.quoteClasses = action.payload 
            }
		)
		.addCase(fetchQuoteClasses.rejected, (state, action) => {
                state.loading = false
            }
		)
        .addCase(
			fetchSkipSuggMarginReasons.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchSkipSuggMarginReasons.fulfilled, (state, action) => {
                state.loading = false
                state.skipSuggMarginReasons = action.payload 
            }
		)
		.addCase(fetchSkipSuggMarginReasons.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
            fetchAdjustmentReasons.fulfilled, (state, action) => {
                state.loading = false
                state.adjustmentReasons = action.payload
            }
        )
        .addCase(
            fetchAdjustmentReasons.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchAdjustmentReasons.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
			fetchVendorRateContracts.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchVendorRateContracts.fulfilled, (state, action) => {
                state.loading = false
                state.vendorRateContracts = action.payload 
            }
		)
		.addCase(fetchVendorRateContracts.rejected, (state, action) => {
                state.loading = false
            }
        )
        .addCase(
			fetchCompanyTags.pending, (state) => {
                state.loading = true
            }
		)
		.addCase(
			fetchCompanyTags.fulfilled, (state, action) => {
                state.loading = false
                state.companyTags = action.payload 
            }
		)
		.addCase(
            fetchCompanyTags.rejected, (state, action) => {
                state.loading = false
            }
        )
    }
})

export const { addChequeBookAction, editChequeBookAction, deleteChequeBookAction, updateChequeBooksSearchOptions, updateChequeBooksSearchParams } = commonSlice.actions

export default commonSlice.reducer